import { render, staticRenderFns } from "./ProjectLogItem.vue?vue&type=template&id=310b42ce&scoped=true&"
import script from "./ProjectLogItem.vue?vue&type=script&lang=ts&"
export * from "./ProjectLogItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLogItem.vue?vue&type=style&index=0&id=310b42ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b42ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
